export default __webpack_public_path__ + "static/media/tabler-icon-plus.10134ad8.svg";